import { RfqForm } from '../components/RfqForm'
import { usePageMeta } from '../lib/meta'

export function AdvertisePage() {
  usePageMeta(
    'Advertise & List Your Rates — Forwarders & Carriers | FreightRatesMCP',
    'Reach shippers checking ocean freight rates from Asia. Feature your rates, receive booking leads, and sponsor high-intent lane pages on FreightRatesMCP.',
    '/advertise',
    ['en']
  )
  return (
    <div className="mx-auto max-w-3xl px-5 pt-14 pb-10">
      <h1 className="font-display text-4xl font-light text-center">List your rates. Win the booking.</h1>
      <p className="mt-3 text-center text-muted leading-relaxed">
        Shippers arrive on FreightRatesMCP with intent: they know their lane and they're ready to
        book. Put your rate in front of them.
      </p>

      <div className="mt-8 grid gap-4 sm:grid-cols-3">
        {[
          {
            h: 'Featured lane placement',
            p: 'Your rate and brand at the top of the lane pages you serve, priced per trade lane.',
          },
          {
            h: 'Booking leads (RFQs)',
            p: 'Receive matched, high-intent quote requests for your lanes. Pay per lead or per booking.',
          },
          {
            h: 'Rate feed listing',
            p: 'Carriers & NVOCCs: push your own rates into the index and get attributed on every card.',
          },
        ].map((c) => (
          <div key={c.h} className="rounded-lg border border-border-strong bg-surface-0 p-5">
            <div className="font-display font-bold text-signal">{c.h}</div>
            <p className="mt-2 text-sm text-muted leading-relaxed">{c.p}</p>
          </div>
        ))}
      </div>

      <div className="mt-8 rounded-lg border border-signal/40 bg-surface-0 p-6">
        <h2 className="font-display text-xl font-bold">Talk to us</h2>
        <p className="mt-1 text-sm text-muted">
          Forwarder, NVOCC or carrier? Tell us your lanes and we'll set up placement or a rate feed.
        </p>
        <div className="mt-4">
          <RfqForm />
        </div>
      </div>
    </div>
  )
}
